<script>
import { Bar } from 'vue-chartjs'
export default {
	extends: Bar,
	props: ['data', 'options'],
	
   methods: {
        getAgeWiseUsers() {
            
                this.datacollection.labels = ["1st", "2nd", "3rd", "4th", "5th"];
                this.datacollection.datasets[0].data = [40, 47, 44, 38, 27];
                this.renderChart(this.datacollection, {responsive: true, maintainAspectRatio: false});
        }

    },
    computed: {

    },
    mixins: [Bar],
    data(){
        return {
            is_loading: false,
            datacollection: {
                labels:["IT", "CLIENT SERVICING", "BUSINESS TECHNOLOGY GROUP", "Innovation Lab", "LIABILITIES- MIS & COSTING"],
                datasets: [
                    {
                      label: 'Available',
                      backgroundColor: 'rgba(4,76,130)',
                      borderWidth: 1,
                      data: [40, 47, 44, 38, 27],
                      stack: 1
                    },
                    {
				      label: "Occupied",
				      backgroundColor: "rgba(241,99,27)",
				      data: [40, 50, 20, 34, 45],
				      stack: 2
				    },
				],
            },
                chartoptions: {
			    responsive: true,
			    lineTension: 1,
			    scales: {
			      xAxes: [{
			        ticks: {
			          beginAtZero: true,
			          padding: 25,
			        },
			        stacked: true,
			      }]
			    }
			  }
            
        }

    },
    mounted() {
        this.getAgeWiseUsers();
    }
 
};
</script>